module.exports = __webpack_public_path__ + "static/media/icon_3.05dfe8d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/icon_3.svg
// module id = 371
// module chunks = 0